"use strict";

exports.__esModule = true;
var _Flex = _interopRequireDefault(require("./Flex"));
exports.default = _Flex.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}